import { FileText } from 'lucide-react';
import { formatRange } from './utils';
import {
  formatMinor,
  TaxEmptyState,
  TaxLineRow,
  TaxReportCard,
  TaxStatCell,
  TaxStatStrip,
} from './taxReportShared';

interface Data {
  type: string;
  periodStart: string;
  periodEnd: string;
  turnoverMinor: number;
  boxTotals: Record<string, number>;
  totalExpensesMinor: number;
  netProfitMinor: number;
}

export function TaxSa103Report({ data }: { data: Record<string, unknown> }) {
  const d = data as unknown as Data;
  const boxes = Object.entries(d.boxTotals ?? {});

  return (
    <TaxReportCard
      icon={FileText}
      title="SA103 — Self-Employment"
      badge={formatRange(d.periodStart, d.periodEnd)}
    >
      <TaxStatStrip>
        <TaxStatCell label="Turnover" value={formatMinor(d.turnoverMinor, 'GBP')} />
        <TaxStatCell label="Total expenses" value={formatMinor(d.totalExpensesMinor, 'GBP')} />
        <TaxStatCell label="Net profit" value={formatMinor(d.netProfitMinor, 'GBP')} emphasis />
      </TaxStatStrip>

      {boxes.length === 0 ? (
        <TaxEmptyState message="No SA103-mapped expense boxes for this period." />
      ) : (
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-surface-50/60 text-[11px] uppercase tracking-[0.06em] text-surface-500">
              <th className="px-4.5 py-2 text-left font-medium">Box</th>
              <th className="px-4.5 py-2 text-right font-medium">Amount</th>
            </tr>
          </thead>
          <tbody>
            {boxes.map(([ref, minor]) => (
              <TaxLineRow key={ref} label={ref} value={formatMinor(minor, 'GBP')} />
            ))}
          </tbody>
        </table>
      )}
    </TaxReportCard>
  );
}
